export default "__VITE_ASSET__2f460ccd__"